import React, { FC } from 'react';
import { Button } from '@unbooking/ui-modules';
import { Close } from '@assets/svg/icons';
import './styles.scss';

interface IModal {
  children?: React.ReactNode;
  closeBtn?: boolean;
  title?: string;
  variant?: 'default' | 'dark' | 'light';
  visible?: boolean;
  onClose?: () => void;
}

const Modal: FC<IModal> = ({
  children,
  closeBtn = false,
  title,
  variant = 'default',
  visible = false,
  onClose,
}) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {visible && (
      <div className="modal">
        <div aria-hidden="true" className="modal-bg" onClick={() => onClose?.()} />
        <div className={`modal-box-${variant}`}>
          {closeBtn && (
            <Button
              className="btn-close"
              icon={<Close />}
              variant="icon"
              onClick={() => onClose?.()}
            />
          )}
          {title && <div className="modal-header">{title}</div>}
          <div className="modal-content">{children}</div>
        </div>
      </div>
    )}
  </>
);

export default Modal;
